import React from "react";
import { Link } from "react-router-dom";
import { Mail, Phone, MapPin, Instagram, Facebook } from "lucide-react";
import { siteConfig, navigationLinks } from "../mock";
import { openExternal } from "../lib/external";

const Footer = () => {
  return (
    <footer className="bg-brand-900 text-white/80">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="flex items-center gap-4 mb-5">
            <img
              src={siteConfig.logoTransparent}
              alt="CATV"
              className="h-16 w-auto object-contain"
            />
            <div>
              <p className="text-white font-bold text-lg">CATV</p>
              <p className="text-[11px] uppercase tracking-widest bg-gradient-to-r from-ember-400 to-ember-600 bg-clip-text text-transparent font-semibold">
                Clube de Atletismo de Torres Vedras
              </p>
            </div>
          </div>
          <p className="text-white/60 leading-relaxed max-w-md">
            Promovendo o atletismo, a saúde e o espírito desportivo na comunidade
            de Torres Vedras desde {siteConfig.founded}.
          </p>
          <div className="flex items-center gap-3 mt-6">
            <a
              href={siteConfig.instagram}
              onClick={openExternal(siteConfig.instagram)}
              aria-label="Instagram"
              className="w-10 h-10 rounded-full bg-white/5 hover:bg-gradient-to-br hover:from-ember-400 hover:to-ember-600 text-white/80 hover:text-white border border-white/10 flex items-center justify-center transition-colors cursor-pointer"
            >
              <Instagram className="w-4 h-4" />
            </a>
            <a
              href={siteConfig.facebook}
              onClick={openExternal(siteConfig.facebook)}
              aria-label="Facebook"
              className="w-10 h-10 rounded-full bg-white/5 hover:bg-gradient-to-br hover:from-ember-400 hover:to-ember-600 text-white/80 hover:text-white border border-white/10 flex items-center justify-center transition-colors cursor-pointer"
            >
              <Facebook className="w-4 h-4" />
            </a>
            <a
              href={`mailto:${siteConfig.email}`}
              aria-label="Email"
              className="w-10 h-10 rounded-full bg-white/5 hover:bg-gradient-to-br hover:from-ember-400 hover:to-ember-600 text-white/80 hover:text-white border border-white/10 flex items-center justify-center transition-colors"
            >
              <Mail className="w-4 h-4" />
            </a>
          </div>
        </div>

        <div>
          <p className="text-white font-semibold mb-4">Navegação</p>
          <ul className="space-y-2.5">
            {navigationLinks.map((l) => (
              <li key={l.path}>
                <Link
                  to={l.path}
                  className="text-white/60 hover:text-ember-400 transition-colors text-sm"
                >
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <p className="text-white font-semibold mb-4">Contactos</p>
          <ul className="space-y-3 text-sm">
            <li className="flex items-start gap-3">
              <Mail className="w-4 h-4 mt-0.5 text-ember-400 shrink-0" />
              <a
                href={`mailto:${siteConfig.email}`}
                className="hover:text-ember-400 transition-colors break-all"
              >
                {siteConfig.email}
              </a>
            </li>
            <li className="flex items-start gap-3">
              <Phone className="w-4 h-4 mt-0.5 text-ember-400 shrink-0" />
              <span>{siteConfig.phone}</span>
            </li>
            <li className="flex items-start gap-3">
              <MapPin className="w-4 h-4 mt-0.5 text-ember-400 shrink-0" />
              <span>{siteConfig.location}</span>
            </li>
            <li className="flex items-start gap-3">
              <Instagram className="w-4 h-4 mt-0.5 text-ember-400 shrink-0" />
              <a
                href={siteConfig.instagram}
                onClick={openExternal(siteConfig.instagram)}
                className="hover:text-ember-400 transition-colors cursor-pointer"
              >
                @clubeatletismotv
              </a>
            </li>
            <li className="flex items-start gap-3">
              <Facebook className="w-4 h-4 mt-0.5 text-ember-400 shrink-0" />
              <a
                href={siteConfig.facebook}
                onClick={openExternal(siteConfig.facebook)}
                className="hover:text-ember-400 transition-colors cursor-pointer"
              >
                CATV no Facebook
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-6 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-white/40">
          <p>
            © {new Date().getFullYear()} {siteConfig.fullName}. Todos os direitos reservados.
          </p>
          <p>Feito com dedicação em Torres Vedras.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
